import SEOHelmet from '@/components/feature/SEOHelmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const CONTACT_FORM_ADDR = 'https://readdy.ai/api/form/d9qrqdee3oq4jqumtpqg';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '黑料不打烊的爆料内容可信度如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们的内容来源于多方信源交叉验证，包括业内人士爆料、公开信息梳理和深度调查。每篇爆料都经过编辑团队审核，力求客观真实。但娱乐圈信息复杂多变，建议读者理性看待，以官方信息为准。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向黑料不打烊爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过本页面的联系表单或发送邮件至 tips@heiliaobudayang.com 向我们提供爆料线索。我们承诺对爆料人信息严格保密，并对有价值的线索给予相应奖励。',
      },
    },
    {
      '@type': 'Question',
      name: '黑料不打烊更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们保持24小时全天候更新，每天至少推送5-10条最新爆料。重大突发娱乐新闻会在第一时间跟进报道，确保读者不错过任何重要信息。',
      },
    },
    {
      '@type': 'Question',
      name: '网站内容是否涉及侵犯明星隐私？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们严格遵守相关法律法规，所有报道均基于公开信息或合法来源的线索。我们不鼓励也不参与任何形式的非法跟踪、偷拍或侵犯个人隐私的行为。如发现内容不当，可通过联系邮箱反馈，我们将在核实后及时处理。',
      },
    },
    {
      '@type': 'Question',
      name: '如何订阅黑料不打烊的每日简报？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以在首页底部的订阅区输入邮箱地址即可免费订阅每日吃瓜简报，或在关于我们页面使用联系表单注明"订阅简报"。',
      },
    },
  ],
};

export default function AboutPage() {
  const [formName, setFormName] = useState('');
  const [formEmail, setFormEmail] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpVal = (formData.get('company_alt') as string || '').trim();

    if (hpVal) {
      setFormStatus('success');
      setFormName('');
      setFormEmail('');
      setFormMessage('');
      return;
    }

    if (formMessage.length > 500) {
      setFormStatus('error');
      setFormError('留言内容不能超过500个字符');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const response = await fetch(CONTACT_FORM_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          name: formName.trim(),
          email: formEmail.trim(),
          message: formMessage.trim(),
        } as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setFormStatus('success');
        setFormName('');
        setFormEmail('');
        setFormMessage('');
      } else {
        const serverMsg = (parsed && ((parsed as Record<string, unknown>).meta as Record<string, unknown>)?.message as string)
          || (parsed && (parsed as Record<string, unknown>).message as string)
          || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormError('提交失败，请稍后重试');
        } else {
          setFormStatus('error');
          setFormError(serverMsg || '提交失败，请稍后重试');
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <>
      <SEOHelmet
        title="关于我们 - 黑料不打烊"
        description="黑料不打烊是全天候追踪娱乐圈最新爆料的娱乐新闻平台，致力于提供第一手明星黑料与劲爆内幕。了解品牌故事、口碑声誉与联系方式。"
        keywords="黑料不打烊,关于我们,娱乐爆料平台,联系我们"
        canonicalUrl="https://www.heiliaobudayang.com/about"
        schema={faqSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-20">
        <section className="py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <div className="text-center mb-14">
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className="ri-fire-line text-3xl text-primary-600"></i>
              </div>
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">关于黑料不打烊</h1>
              <p className="text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                全网最劲爆的娱乐圈爆料平台，24小时不间断，吃瓜永不缺货
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-xl text-primary-600"></i>
                </div>
                <div className="text-3xl font-bold text-primary-600 mb-1">1000+</div>
                <p className="text-sm text-foreground-500">独家爆料文章</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-user-heart-line text-xl text-accent-600"></i>
                </div>
                <div className="text-3xl font-bold text-accent-600 mb-1">500万+</div>
                <p className="text-sm text-foreground-500">月活跃吃瓜群众</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-time-line text-xl text-secondary-600"></i>
                </div>
                <div className="text-3xl font-bold text-secondary-600 mb-1">24/7</div>
                <p className="text-sm text-foreground-500">全天候不间断更新</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-background-100/70">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">品牌故事</h2>
              </div>
            </div>

            <div className="prose-custom text-foreground-700 leading-relaxed space-y-5">
              <p className="text-base md:text-lg">
                <strong className="text-foreground-950">黑料不打烊</strong>成立于2024年，是国内领先的娱乐八卦新闻聚合平台。我们致力于为广大"吃瓜群众"提供最新、最快、最劲爆的娱乐圈内幕消息。
              </p>
              <p>
                在信息碎片化的时代，娱乐圈的真相往往被精心包装的公关稿所掩盖。黑料不打烊的诞生，就是为了撕开这层华丽的外衣，让公众看到明星和娱乐圈的真实面貌。我们的编辑团队由资深娱乐记者、前公关从业者和深度调查记者组成，拥有丰富的行业人脉和信息渠道。
              </p>
              <p>
                我们的核心理念是<strong className="text-foreground-950">"真实、快速、独家"</strong>。每一篇爆料都经过多方信源交叉验证，确保内容的可信度。我们不站队、不偏袒，只报道事实，让读者自己判断。
              </p>
              <p>
                自成立以来，黑料不打烊已累计发布超过1000篇独家爆料，月活跃用户突破500万。我们的报道多次被主流媒体引用，成为了娱乐圈爆料领域最具影响力的平台之一。
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">口碑声誉</h2>
              </div>
              <p className="text-sm text-foreground-500">来自吃瓜群众的真实评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 mb-3 leading-relaxed">
                  "每天必刷的网站，爆料速度确实快，而且内容比其他平台劲爆多了。上次那个顶流塌房的瓜，全网就这里最快！"
                </p>
                <span className="text-xs text-foreground-400">—— 资深吃瓜人 小李</span>
              </div>

              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 mb-3 leading-relaxed">
                  "关注半年了，内容质量确实高。虽然有时候标题有点标题党，但内容都是有料的，不是那种纯靠吹的营销号。"
                </p>
                <span className="text-xs text-foreground-400">—— 娱乐编辑 王姐</span>
              </div>

              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 mb-3 leading-relaxed">
                  "分类做得很好，想看什么类型的一目了然。就是希望更新再勤快点，有时候等不及想看新的瓜哈哈哈。"
                </p>
                <span className="text-xs text-foreground-400">—— 追星女孩 小陈</span>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-background-100/70">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">联系我们</h2>
              </div>
              <p className="text-sm text-foreground-500">有料想爆？有瓜想分享？随时联系我们</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">爆料邮箱</h4>
                    <p className="text-sm text-foreground-500">tips@heiliaobudayang.com</p>
                    <p className="text-xs text-foreground-400 mt-1">24小时内回复，严格保护爆料人隐私</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-lg text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">爆料热线</h4>
                    <p className="text-sm text-foreground-500">400-888-6666</p>
                    <p className="text-xs text-foreground-400 mt-1">工作日 9:00 - 18:00</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-500">北京市朝阳区建国路88号SOHO现代城A座</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-heading font-bold text-foreground-900 mb-4">给我们留言</h4>
                {formStatus === 'success' ? (
                  <div className="flex items-center justify-center gap-2 text-accent-600 py-8">
                    <i className="ri-check-double-line text-xl"></i>
                    <span className="font-medium">留言发送成功！我们会尽快回复您~</span>
                  </div>
                ) : (
                  <form onSubmit={handleFormSubmit} data-readdy-form className="space-y-4">
                    <input
                      type="text"
                      name="company_alt"
                      className="form-hp"
                      tabIndex={-1}
                      autoComplete="off"
                      readOnly
                      aria-hidden="true"
                    />
                    <div>
                      <input
                        type="text"
                        name="name"
                        value={formName}
                        onChange={(e) => setFormName(e.target.value)}
                        placeholder="您的称呼"
                        className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        value={formEmail}
                        onChange={(e) => setFormEmail(e.target.value)}
                        placeholder="您的邮箱"
                        className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <textarea
                        name="message"
                        value={formMessage}
                        onChange={(e) => setFormMessage(e.target.value)}
                        placeholder="请输入留言内容（限500字）"
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        required
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1 text-right">{formMessage.length}/500</p>
                    </div>
                    <button
                      type="submit"
                      disabled={formStatus === 'loading'}
                      className="w-full py-2.5 bg-primary-500 text-white font-bold rounded-lg hover:bg-primary-600 disabled:opacity-60 transition-all duration-200 whitespace-nowrap"
                    >
                      {formStatus === 'loading' ? (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-loader-4-line animate-spin"></i>发送中
                        </span>
                      ) : (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-send-plane-line"></i>发送留言
                        </span>
                      )}
                    </button>
                    {formStatus === 'error' && formError && (
                      <p className="text-sm text-red-500 text-center">{formError}</p>
                    )}
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">常见问题</h2>
              </div>
              <p className="text-sm text-foreground-500">关于黑料不打烊的一些常见疑问</p>
            </div>

            <div className="space-y-4">
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-bold text-foreground-900 mb-2">黑料不打烊的爆料内容可信度如何？</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们的内容来源于多方信源交叉验证，包括业内人士爆料、公开信息梳理和深度调查。每篇爆料都经过编辑团队审核，力求客观真实。但娱乐圈信息复杂多变，建议读者理性看待，以官方信息为准。
                </p>
              </div>

              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-bold text-foreground-900 mb-2">如何向黑料不打烊爆料？</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  您可以通过本页面的联系表单或发送邮件至 tips@heiliaobudayang.com 向我们提供爆料线索。我们承诺对爆料人信息严格保密，并对有价值的线索给予相应奖励。
                </p>
              </div>

              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-bold text-foreground-900 mb-2">黑料不打烊更新频率如何？</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们保持24小时全天候更新，每天至少推送5-10条最新爆料。重大突发娱乐新闻会在第一时间跟进报道，确保读者不错过任何重要信息。
                </p>
              </div>

              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-bold text-foreground-900 mb-2">网站内容是否涉及侵犯明星隐私？</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们严格遵守相关法律法规，所有报道均基于公开信息或合法来源的线索。我们不鼓励也不参与任何形式的非法跟踪、偷拍或侵犯个人隐私的行为。如发现内容不当，可通过联系邮箱反馈，我们将在核实后及时处理。
                </p>
              </div>

              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <h4 className="font-bold text-foreground-900 mb-2">如何订阅黑料不打烊的每日简报？</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  您可以在首页底部的订阅区输入邮箱地址即可免费订阅每日吃瓜简报，或在关于我们页面使用联系表单注明"订阅简报"。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}